<template>
  <div class="auth">
    <div class="auth_item" v-for="(item, idx) in brandItem" :key="idx">
      <h1>
        <span>{{ item.title }}</span>
        <div class="button" @click="seting(item.eventType)" v-if="!item.unShowSeting">去设置</div>
      </h1>
      <div class="desc">{{ item.text }}</div>
      <div class="img_wappper">
        <img
          :src="require(`../assets/img/brand/${brandType}/${idx + 1}.png`)"
          alt=""
        />
      </div>
    </div>
  </div>
</template>
<script>
import brandList from "../utils/brand_list";
export default {
  computed: {
    brandType() {
      return this.$route.params.brand || "huawei";
    },
    brandItem() {
      let content = brandList[this.brandType];
      return content.contentList;
    },
  },
  methods: {
    seting(type) {
      window.LbsGuard &&
        window.LbsGuard.onPermissionCallback(this.brandType, type);
    },
  },
};
</script>

<style lang="less">
.auth {
  padding: 0 4.4vw 5.333vw;
  box-sizing: border-box;
  .auth_item {
    h1 {
      padding: 4.4vw 0;
      display: flex;
      flex-direction: row;
      align-items: center;
      justify-content: space-between;
      span {
        font-weight: bold;
        color: #333333;
        font-size: 5.067vw;
      }
      .button {
        text-align: center;
        line-height: 7.733vw;
        width: 22.267vw;
        height: 7.733vw;
        background: #34dda5;
        border-radius: 3.867vw;
        color: #fff;
        font-size: 3.333vw;
      }
    }
    .desc {
      font-size: 3.333vw;
      font-weight: 400;
      color: #4c5560;
      line-height: 5.6vw;
    }
    .img_wappper {
      margin-top: 1.333vw;
      img {
        width: 100%;
      }
    }
  }
}
</style>